import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { TL_NODE_ENV } from '@src/public/constants';
import { isGrounds } from '@src/public/utils/app';
import { groundsDispatch } from './utils';
import styles from './index.css';

const Link = ({
    children,
    to,
    type = 'web',
    target,
    className = '',
    style = {},
    needLinkAnalyze = false,
    timelineId,
}) => {
    const lockRef = useRef(false);

    if (isGrounds) {
        const handleSpanClick = () => {
            if (!lockRef.current) {
                lockRef.current = true;
                groundsDispatch({ to, type, needLinkAnalyze, timelineId }).finally(() => {
                    lockRef.current = false;
                });
            }
        };

        return (
            <span onClick={handleSpanClick} className={classNames(styles.span, className)} style={style}>
                {children}
            </span>
        );
    } else {

        const searchParams = new URLSearchParams(window.location.search);
        const from = searchParams.get('from');
        let qs = '';

        if (from === 'hms') {
            qs = to.includes('?') ? '&from=hms' : '?from=hms';
        }

        return (
            <a href={`${to}${qs}`} {...(target ? { target } : {})} className={classNames(styles.a, className)} style={style}>
                {children}
            </a>
        );
    }
};

Link.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.array]),
    to: PropTypes.string,
    type: PropTypes.string,
    target: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    needLinkAnalyze: PropTypes.bool,
    timelineId: PropTypes.string,
};

const pathBasePc = TL_NODE_ENV === 'development' ? '/pc/news' : '';
const pathBaseH5 = TL_NODE_ENV === 'development' ? '/mobile/ishare' : '';
const pathBaseClient = TL_NODE_ENV === 'development' ? '/mobile/timeline' : '';
const pathBase = isGrounds ? pathBaseClient : pathBaseH5;
const origin = isGrounds
    ? window.location.origin.replace('ishare', 'timeline')
    : window.location.origin.replace('timeline', 'ishare');

export const linkBasePc = `${window.location.origin}${pathBasePc}`;

export const linkBase = `${origin}${pathBase}`;

// 端内方法形式的跳转
export const dispatchPage = ({ to, type = 'web', needLinkAnalyze = false, timelineId }) => {
    groundsDispatch({ to, type, needLinkAnalyze, timelineId });
};

export default errorBoundary(Link);
